import React, { useState, useEffect } from "react";
import {
  Box,
  Grid2,
  Typography,
  Grid,
  FormControl,
  Select,
  MenuItem,
  Card,
  CardMedia,
  Button,
  CircularProgress,
} from "@mui/material";
import HeaderBack from "../Header_Back";
import events2 from "../../assets/images/events_2.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import useRequests from "../../utils/useRequests";
import Gticket from "../../assets/images/general-ticket.svg";
import Vticket from "../../assets/images/vip-ticket.svg";
import VVticket from "../../assets/images/vvip-ticket.svg";
import { format } from "date-fns";
import Snackbars from "../../utils/Snackbars";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import banner from "../../assets/images/banner.png";
import BackImage from '../../assets/images/back.svg';
import LoginModal from "../components/LoginModal"; // Import the login modal

const Eventresellticketlist = () => {
  const { e_id } = useParams();
  const navigate = useNavigate();
  const { getRequest } = useRequests();
  const [loading, setLoading] = useState(true);
  const [showLoginModal, setShowLoginModal] = useState(false); // State for login modal

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });
  
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  // Check if user is logged in
  const checkUserLoggedIn = () => {
    const TokenDetails = JSON.parse(localStorage.getItem('userDetails'));
    return TokenDetails && !TokenDetails.guestMode;
  };

  // Handle ticket selection and potentially show login modal
  const handleMyTicket = (selectedResellTicket) => {
    if (!checkUserLoggedIn()) {
      setShowLoginModal(true);
      return;
    }
    
    navigate(
      `/resell-market/ticket-list/book-ticket/${selectedResellTicket.r_id}`,
      { state: selectedResellTicket }
    );
  };

  // Show login modal on page load if user is not logged in
  useEffect(() => {
    const fullUrl = window.location.pathname + window.location.search;
    localStorage.setItem("redirectAfterLogin", fullUrl);
    if (!checkUserLoggedIn()) {
        setShowLoginModal(true);
    }
    else {
      fetchEventResellTickets();
    }
  }, []);

  const formatEventDate = (start, end, time) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffInMs = endDate - startDate;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    const day = `${diffInDays + 1}`.toLowerCase();

    const startDay = format(startDate, "dd");
    const endDay = format(endDate, "dd");
    const endmonth = format(endDate, "MMMM");
    const startmonth = format(startDate, "MMMM");
    const year = format(startDate, "yyyy");
    let daysCount = day;
    if (day > 1) {
      daysCount = "10";
    }

    if (startDay === endDay) {
      return {
        formattedDate: `${startDay} ${startmonth} ${year}`,
        daysCount: `${daysCount} Day's Event`,
        time,
      };
    }

    return {
      formattedDate: `${startDay} ${startmonth} - ${endDay} ${endmonth} ${year}`,
      daysCount: `${daysCount} Day's Event`,
      time,
    };
  };

    const formatTicketDate = (ticketDate) => {
    
        const ticket_date = new Date(ticketDate);
        const ticketDay = format(ticket_date, 'dd');
        const tickettmonth = format(ticket_date, 'MMMM');        
        const year = format(ticket_date, 'yyyy');
    return  `${ticketDay} ${tickettmonth} ${year}`;
  };
  const [durationOptions, setDurationOptions] = useState([]);
  const [duration, setduration] = useState("");
  const [particularDurationTicketType, setParticularDurationTicketType] =
    useState([]);
  const [selectedTicketType, setSelectedTicketType] = useState(0);
  const [selectedDate, setSelectedDate] = useState(null);

  const [allTickets, setAllTickets] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [bannerUrl, setbannerUrl] = useState(null);
  const [ticketTypeData, setTicketTypeData] = useState([]);
  const [eventDetail, setEventDetail] = useState({});

  // Fetch tickets and event details
  const fetchEventResellTickets = async () => {
    const response = await getRequest(`event-resell-tickets/${e_id}`);

    if (response && response.code === 200) {
      if (response.data.length !== 0) {
        const ticketsData = Array.isArray(response.data.data)
          ? response.data.data
          : [response.data.data];

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const ValidTickets = ticketsData.filter((ticket) => {
          if (ticket.event_ticket_date) {
            return (
              ticket.resale_status !== "Sold" &&
              new Date(ticket.event_ticket_date) >= today
            );
          }
          return (
            ticket.resale_status !== "Sold" &&
            new Date(ticket.end_datetime) >= today
          );
        });

        const eventDetails = response.data.eventDetails;

        setAllTickets(ValidTickets);
        setTickets(ValidTickets);
        setbannerUrl(response.data.banner);
        setTicketTypeData(response.data.eventTicketTypeData);

        // Set default selected date to event start date (if 1-day event)
        if (eventDetails.one_day_ticket) {
            const startDate = new Date(eventDetails.start_datetime);
            const today = new Date();
            
            // Reset today's time to 00:00:00 for accurate comparison
            today.setHours(0, 0, 0, 0);
            startDate.setHours(0, 0, 0, 0);

            // If start date is in the past, set today's date, else set start date
            if (startDate < today) {
              setSelectedDate(today);
            } else {
              setSelectedDate(startDate);
            }
          }

        let optionsData = [];
        optionsData.push({ value: "0", label: "All Day's" });

        if (response.data.eventTicketTypeData) {
          if (eventDetails.one_day_ticket)
            optionsData.push({ value: "1", label: "Single Day" });
          if (eventDetails.ten_day_ticket)
            optionsData.push({ value: "10", label: "10 Day's" });

          if (optionsData.length !== 0) {
            setDurationOptions(optionsData);
            setduration(optionsData[0].value);

            const eventTicketType = response.data.eventTicketTypeData.filter(
              (type) =>
                type.day_pass === optionsData[0].value ||
                optionsData[0].value === "0"
            );
            setParticularDurationTicketType(eventTicketType);
          }
        }
        const calculatedMaxDays = calculateMaxEventDays(eventDetails.start_datetime, eventDetails.end_datetime);
        setMaxEventDays(calculatedMaxDays);

        const { formattedDate, daysCount, time } = formatEventDate(
          eventDetails.start_datetime,
          eventDetails.end_datetime,
          eventDetails.start_time + " - " + eventDetails.end_time
        );
        setEventDetail({
          name: eventDetails.name,
          address: eventDetails.address,
          date: formattedDate,
          time: time,
          duration: daysCount,
          banner: eventDetails.banner,
        });
      }
    } else {
      console.error("Failed to fetch events:", response?.message);
      setAlertData((prev) => ({
        ...prev,
        variant: "error",
        message: "Failed to fetch events",
      }));
    }
    resetAlertData();
    setLoading(false);
  };

  // Handle duration change
  const handleSelectChangeDuration = (duration) => {
    setduration(duration.target.value);

    if (duration.target.value === "0") {
      setParticularDurationTicketType(ticketTypeData);
      setSelectedTicketType(0);
      setTickets(allTickets);
    } else if (duration.target.value === "1") {

      // Default date = first event date
      const firstDate = new Date(selectedDate);


      const eventTicketType = ticketTypeData.filter(
        (type) =>
          new Date(type.day_date).toDateString() ===
          firstDate.toDateString()
      );
      setParticularDurationTicketType(eventTicketType);

      const EventTickets = allTickets.filter(
        (ticket) =>
          new Date(ticket.day_date).toDateString() ===
          firstDate.toDateString()
      );
      setTickets(EventTickets);
    } else if (duration.target.value === "10") {
      const eventTicketType = ticketTypeData.filter(
        (type) => type.day_pass === "10"
      );
      setParticularDurationTicketType(eventTicketType);

      const EventTickets = allTickets.filter(
        (ticket) => ticket.day_pass === "10"
      );
      setTickets(EventTickets);
    }
  };

  // Handle date change for 1-day events
  const handleDateChange = (date) => {

    setSelectedDate(date);
    const eventTicketType = ticketTypeData.filter((type) => {
    if (!type.day_date) return false; // skip if no date
    return new Date(type.day_date).toDateString() === new Date(date).toDateString();
  });

    setParticularDurationTicketType(eventTicketType);

    setSelectedTicketType(0);

    const EventTickets = allTickets.filter(
      (ticket) =>
        new Date(ticket.day_date).toDateString() ===
        new Date(date).toDateString()
    );
    setTickets(EventTickets);
  };

  // Handle ticket type change
  const handleSelectChangeTicketType = (type) => {
    setSelectedTicketType(type.target.value);
    if (type.target.value == 0) {
      if (duration === "1" && selectedDate) {
        const EventTickets = allTickets.filter(
          (ticket) =>
            new Date(ticket.day_date).toDateString() ===
            new Date(selectedDate).toDateString()
        );
        setTickets(EventTickets);
      } else if (duration === "10") {
        const EventTickets = allTickets.filter(
          (ticket) => ticket.day_pass === "10"
        );
        setTickets(EventTickets);
      } else {
        setTickets(allTickets);
      }
    } else {
      const EventTickets = allTickets.filter(
        (ticket) => ticket.e_t_id === type.target.value
      );
      setTickets(EventTickets);
    }
  };

  const [maxEventDays, setMaxEventDays] = useState(1);
  const calculateMaxEventDays = (startDate, endDate) => {
      if (!startDate || !endDate) return 1;
      
      const start = new Date(startDate);
      const end = new Date(endDate);
      const diffTime = Math.abs(end - start);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 to include both start and end days
      
      return Math.min(diffDays, 10); // Max 10 days
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      
      {/* Add Login Modal */}
      <LoginModal 
        open={showLoginModal} 
        onClose={() => setShowLoginModal(false)}
        onLoginSuccess={() => setShowLoginModal(false)}
      />
      
      <Grid2 className="center-App" container direction="column">
        <Grid2 className='header_details' height={"221px"} sx={{ backgroundImage: `url("${eventDetail.banner ? bannerUrl + eventDetail.banner : banner}")`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <Grid2 className='menu-Link' component={Link}  to={`/dashboard/events-details/${e_id}`}  style={{ cursor: 'pointer', opacity: 1 }}>
                <img src={BackImage} alt="Navbar" width={180} />
            </Grid2>
            <Typography className='categories-name'>Resell Ticket Details</Typography>
            <Grid2 className="back-shadow-img"></Grid2>
        </Grid2>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              minHeight: "300px",
            }}
          >
            <CircularProgress color="primary" />
            <p>Loading ...</p>
          </Box>
        ) : (
          <Box sx={{ padding: "15px 15px", float: "left", width: "100%" }}>
            <Grid2 container spacing={2}>
              <Grid2 item xs={12} sx={{ float: "left", width: "100%" }}>
                <Grid2 className="events-time">
                  <Typography
                    sx={{ fontWeight: 500, color: "#6638A2", fontSize: "19px" }}
                  >
                    {maxEventDays + " Days Event"}{" "}
                  </Typography>
                </Grid2>
                <Typography
                  variant="h2"
                  className="title"
                  sx={{
                    marginBottom: "-5px",
                    fontSize: "32px",
                    marginTop: "20px",
                    color: "#6638A2",
                    fontWeight: "500",
                  }}
                >
                  {" "}
                  {eventDetail.name}
                </Typography>
              </Grid2>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Grid
                    className="event-info fullWidth"
                    sx={{ marginTop: "10px" }}
                  >
                    <Grid className="event-des fullWidth">
                      <Typography
                        sx={{
                          color: "#747688",
                          fontSize: "13px,",
                          fontWeight: "500",
                        }}
                      >
                        Location{" "}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "19px",
                          fontWeight: 500,
                          color: "#120D26",
                        }}
                      >
                        {eventDetail.address}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    className="event-info fullWidth"
                    sx={{ marginTop: "10px" }}
                  >
                    <Grid className="event-des fullWidth">
                      <Typography
                        sx={{
                          color: "#747688",
                          fontSize: "13px,",
                          fontWeight: "500",
                        }}
                      >
                        Event Date/Time
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "19px",
                          fontWeight: 500,
                          color: "#120D26",
                        }}
                      >
                        {eventDetail.date + " " + eventDetail.time}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Duration Dropdown */}
                <Grid item xs={6}>
                  <FormControl fullWidth className="custom-select dropdown">
                    <Typography className="lable-title">Event Pass</Typography>
                    <Select
                      value={duration}
                      onChange={handleSelectChangeDuration}
                    >
                      {durationOptions.map((option) => (
                        <MenuItem value={option.value} key={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Show DatePicker only for 1-day events */}
                {duration === "1" && (
                  <Grid item xs={6}>
                    <FormControl fullWidth className="custom-select datepciker">
                      <Typography className="lable-title">
                        Select Date
                      </Typography>
                      <DatePicker
                        className={`form-control ${
                          selectedDate ? "" : "is-invalid"
                        }`}
                        selected={selectedDate}
                        onChange={handleDateChange}
                        dateFormat="dd-MM-yyyy"
                        placeholderText="DD-MM-YYYY"
                        autoComplete="off"
                        disableKeyboardNavigation
                      />
                    </FormControl>
                  </Grid>
                )}

                {/* Ticket Type Dropdown */}
                {duration != "0" ? (
                  <Grid item xs={6}>
                    <FormControl fullWidth className="custom-select dropdown">
                      <Typography className="lable-title">
                        Ticket Type
                      </Typography>
                      <Select
                        value={selectedTicketType}
                        onChange={handleSelectChangeTicketType}
                      >
                        <MenuItem value={0}>All Ticket</MenuItem>
                        {particularDurationTicketType.map((ticket_type) => (
                          <MenuItem
                            key={ticket_type.e_t_id}
                            value={ticket_type.e_t_id}
                          >
                            {ticket_type.type}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
            </Grid2>

            {/* Ticket List */}
            <div
              container
              spacing={2}
              className="fullWidth"
              style={{ marginTop: "25px" }}
            >
              {tickets.length > 0 ? (
                tickets.map((ticket) => (
                  <div item xs={12} key={ticket.r_id}>
                    <Box className="events-box">
                      <Card
                        sx={{
                          borderRadius: "10px",
                          padding: "15px",
                          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                        }}
                      >
                        <div className="position-relative radius-img-box">
                          <CardMedia
                            component="img"
                            image={Gticket}
                            className="small-event-img-ticket"
                          />
                          <Typography
                            variant="h6"
                            component="div"
                            sx={{
                              float: "left",
                              width: "calc(100% - 80px)",
                              color: "#341439",
                              marginTop: "3px",
                              fontSize: "19px",
                              lineHeight: "27px",
                              fontWeight: "500",
                              paddingLeft: "15px",
                            }}
                          >{`${ticket.type} Ticket, ${ticket.day_pass} Day Pass, ${ticket.day_pass == "1"?formatTicketDate(ticket.event_ticket_date)+",":""} ${ticket.resale_quantity} Person`}</Typography>
                          <Typography
                            variant="h6"
                            component="div"
                            sx={{
                              float: "left",
                              width: "calc(100% - 80px)",
                              color: "#341439",
                              marginTop: "0px",
                              fontSize: "17px",
                              lineHeight: "27px",
                              fontWeight: "400",
                              paddingLeft: "15px",
                            }}
                          >
                            Seller:{" "}
                            {`${ticket.seller_first_name?ticket.seller_first_name +" "+ticket.seller_last_name: ticket.seller_phone}`}
                          </Typography>
                        </div>
                        <Grid2
                          className="button-bottom fullWidth"
                          sx={{ marginTop: "0px" }}
                          fullWidth
                        >
                          <Button
                            className="btn-common-border btn-success"
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{ marginTop: 2 }}
                            onClick={() => handleMyTicket(ticket)}
                          >
                            On Sell for ₹{ticket.resale_price}{" "}
                          </Button>
                        </Grid2>
                      </Card>
                    </Box>
                  </div>
                ))
              ) : (
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ textAlign: "center", marginTop: "20px" }}
                >
                  No tickets are available.
                </Typography>
              )}
            </div>
          </Box>
        )}
      </Grid2>
    </Box>
  );
};

export default Eventresellticketlist;
